<template>
  <div class="lib-manage-wrapper">
    <lib-list v-if="currentModule === 'lib'" @showWordList="showWordList"></lib-list>
    <word-list v-if="currentModule === 'word'" :lib="lib" @goBack="currentModule = 'lib'"></word-list>
  </div>
</template>
<script>
import LibList from './components/LibList.vue'
import WordList from './components/WordList.vue'

export default {
  name: 'SpecialWordManagement',
  data() {
    return {
      currentModule: 'lib',
      lib: {}
    }
  },
  methods: {
    showWordList(val) {
      this.lib = val
      this.currentModule = 'word'
    }
  },
  created() {
    document.title = '专有词管理'
  },
  components: { WordList, LibList }
}
</script>
<style lang="scss" scoped>
.lib-manage-wrapper {
  width: 100%;
  height: 100%;
  padding: 10px 18px 0 18px;
}
</style>
<style lang="scss">
.lib-manage-wrapper {
  .common-list-wrapper {
    .common-list {
      height: calc(100vh - 280px);
    }
    .el-scrollbar {
      .el-scrollbar__wrap {
        padding-bottom: 15px !important;
      }
    }
  }
}
</style>
